
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.BrandProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  profilePicture: 'profilePicture',
  companyName: 'companyName',
  vatNumber: 'vatNumber',
  address: 'address',
  city: 'city',
  zipCode: 'zipCode',
  countryId: 'countryId',
  phone: 'phone',
  description: 'description',
  interest: 'interest',
  followUp: 'followUp',
  mainFirstName: 'mainFirstName',
  mainLastName: 'mainLastName',
  mainEmail: 'mainEmail',
  mainPhone: 'mainPhone',
  mainMobile: 'mainMobile',
  mainTitle: 'mainTitle',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  website: 'website'
};

exports.Prisma.ConceptScalarFieldEnum = {
  id: 'id',
  title: 'title',
  authorId: 'authorId',
  type: 'type',
  coverImage: 'coverImage',
  state: 'state',
  sustainableElements: 'sustainableElements',
  mainCategory: 'mainCategory',
  subcategory1: 'subcategory1',
  subcategory2: 'subcategory2',
  description: 'description',
  revision: 'revision',
  tags: 'tags',
  pricing: 'pricing',
  reviewerId: 'reviewerId',
  boughtById: 'boughtById',
  reservedById: 'reservedById',
  templateId: 'templateId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  submissionDate: 'submissionDate',
  pitchId: 'pitchId'
};

exports.Prisma.ConceptFileScalarFieldEnum = {
  id: 'id',
  conceptId: 'conceptId',
  name: 'name',
  location: 'location',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ConceptLogScalarFieldEnum = {
  id: 'id',
  conceptId: 'conceptId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  conceptRevision: 'conceptRevision',
  coverImage: 'coverImage',
  description: 'description',
  mainCategory: 'mainCategory',
  subcategory1: 'subcategory1',
  subcategory2: 'subcategory2',
  sustainableElements: 'sustainableElements',
  tags: 'tags',
  title: 'title'
};

exports.Prisma.ConceptActivityScalarFieldEnum = {
  id: 'id',
  conceptId: 'conceptId',
  type: 'type',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ConceptReviewScalarFieldEnum = {
  id: 'id',
  conceptId: 'conceptId',
  aboutReview: 'aboutReview',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  revision: 'revision'
};

exports.Prisma.ConceptSectionReviewScalarFieldEnum = {
  id: 'id',
  sectionId: 'sectionId',
  comment: 'comment',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  conceptRevision: 'conceptRevision'
};

exports.Prisma.ConceptSectionScalarFieldEnum = {
  id: 'id',
  title: 'title',
  type: 'type',
  layout: 'layout',
  images: 'images',
  text: 'text',
  conceptId: 'conceptId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  position: 'position'
};

exports.Prisma.ConceptSectionLogScalarFieldEnum = {
  id: 'id',
  sectionId: 'sectionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  conceptRevision: 'conceptRevision',
  images: 'images',
  layout: 'layout',
  text: 'text',
  title: 'title',
  type: 'type'
};

exports.Prisma.ConceptStateHistoryScalarFieldEnum = {
  id: 'id',
  conceptId: 'conceptId',
  state: 'state',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ConceptTemplateScalarFieldEnum = {
  id: 'id',
  default: 'default',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ConceptTemplateSectionScalarFieldEnum = {
  id: 'id',
  title: 'title',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  layout: 'layout',
  conceptTemplateId: 'conceptTemplateId',
  position: 'position'
};

exports.Prisma.CountryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  alpha2: 'alpha2',
  alpha3: 'alpha3',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DesignerPortfolioScalarFieldEnum = {
  id: 'id',
  designerId: 'designerId',
  title: 'title',
  description: 'description',
  image: 'image',
  link: 'link',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DesignerProfileScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  isVisible: 'isVisible',
  isVerified: 'isVerified',
  canBePublished: 'canBePublished',
  isPublished: 'isPublished',
  slug: 'slug',
  firstName: 'firstName',
  lastName: 'lastName',
  address: 'address',
  city: 'city',
  zipCode: 'zipCode',
  countryId: 'countryId',
  phone: 'phone',
  level: 'level',
  workTitle: 'workTitle',
  linkedinProfile: 'linkedinProfile',
  website: 'website',
  mainDesignCompetency: 'mainDesignCompetency',
  profilePicture: 'profilePicture',
  educationLevel: 'educationLevel',
  educationProgram: 'educationProgram',
  educationTitle: 'educationTitle',
  educationYears: 'educationYears',
  educationInstitution: 'educationInstitution',
  educationCity: 'educationCity',
  educationCountryId: 'educationCountryId',
  diploma: 'diploma',
  billingCompanyName: 'billingCompanyName',
  billingAddress: 'billingAddress',
  billingCity: 'billingCity',
  billingZipCode: 'billingZipCode',
  billingCountryId: 'billingCountryId',
  billingVatNumber: 'billingVatNumber',
  billingPhone: 'billingPhone',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  bio: 'bio'
};

exports.Prisma.LegalDocumentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  location: 'location',
  revision: 'revision',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NewsFeedScalarFieldEnum = {
  id: 'id',
  title: 'title',
  content: 'content',
  image: 'image',
  type: 'type',
  visibleToBrands: 'visibleToBrands',
  visibleToDesigners: 'visibleToDesigners',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishDate: 'publishDate'
};

exports.Prisma.PasswordResetScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  token: 'token',
  expiresAt: 'expiresAt',
  usedAt: 'usedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PermissionScalarFieldEnum = {
  id: 'id',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PitchScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  desiredRetailPriceOption: 'desiredRetailPriceOption',
  distributionChannelOption: 'distributionChannelOption',
  state: 'state',
  assistanceRegisteringAwards: 'assistanceRegisteringAwards',
  assistanceRegisteringCollaboration: 'assistanceRegisteringCollaboration',
  assistanceRegisteringDesign: 'assistanceRegisteringDesign',
  assistanceRegisteringMarketing: 'assistanceRegisteringMarketing',
  assistanceRegisteringRelations: 'assistanceRegisteringRelations',
  brandId: 'brandId',
  brandPaymentOption: 'brandPaymentOption',
  brandValues: 'brandValues',
  conceptTemplateId: 'conceptTemplateId',
  conceptsVisibleToBrands: 'conceptsVisibleToBrands',
  customBrandName: 'customBrandName',
  designStyle: 'designStyle',
  designerPaymentOption: 'designerPaymentOption',
  desiredRetailPriceDescription: 'desiredRetailPriceDescription',
  discloseBrandName: 'discloseBrandName',
  distributionChannelDescription: 'distributionChannelDescription',
  estimatedDuration: 'estimatedDuration',
  functionality: 'functionality',
  intendedLaunchDate: 'intendedLaunchDate',
  isPrivate: 'isPrivate',
  launchDate: 'launchDate',
  mainCategory: 'mainCategory',
  manufacturingRequirements: 'manufacturingRequirements',
  marketInformation: 'marketInformation',
  materials: 'materials',
  numberOfParticipants: 'numberOfParticipants',
  otherRemarks: 'otherRemarks',
  packagingDescription: 'packagingDescription',
  packagingIncluded: 'packagingIncluded',
  purpose: 'purpose',
  regulatoryRequirements: 'regulatoryRequirements',
  requiresNDA: 'requiresNDA',
  subcategory1: 'subcategory1',
  subcategory2: 'subcategory2',
  sustainablePrinciples: 'sustainablePrinciples',
  targetAudience: 'targetAudience',
  title: 'title',
  toBeReviewed: 'toBeReviewed',
  winningConceptId: 'winningConceptId',
  initiatedProjectId: 'initiatedProjectId'
};

exports.Prisma.PitchFeedbackScalarFieldEnum = {
  id: 'id',
  pitchId: 'pitchId',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  projectId: 'projectId'
};

exports.Prisma.PitchFileScalarFieldEnum = {
  id: 'id',
  pitchId: 'pitchId',
  userId: 'userId',
  location: 'location',
  uploader: 'uploader',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name'
};

exports.Prisma.PitchActivityScalarFieldEnum = {
  id: 'id',
  pitchId: 'pitchId',
  type: 'type',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PitchDesignerInvitationScalarFieldEnum = {
  id: 'id',
  pitchId: 'pitchId',
  designerId: 'designerId',
  expiresAt: 'expiresAt',
  acceptedAt: 'acceptedAt',
  declinedAt: 'declinedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  cancelledAt: 'cancelledAt'
};

exports.Prisma.ProjectScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  state: 'state',
  fromPitchId: 'fromPitchId',
  brandId: 'brandId',
  conceptTemplateId: 'conceptTemplateId',
  customBrandName: 'customBrandName',
  designerId: 'designerId',
  duration: 'duration',
  endDate: 'endDate',
  feedbackAcknowledgedAt: 'feedbackAcknowledgedAt',
  intendedLaunchDate: 'intendedLaunchDate',
  mainCategory: 'mainCategory',
  name: 'name',
  nextPhaseId: 'nextPhaseId',
  otherRemarks: 'otherRemarks',
  phase: 'phase',
  pitchConceptId: 'pitchConceptId',
  projectEndedAt: 'projectEndedAt',
  renumerationOptions: 'renumerationOptions',
  sentForReview: 'sentForReview',
  startDate: 'startDate',
  subcategory1: 'subcategory1',
  subcategory2: 'subcategory2',
  winningConceptId: 'winningConceptId',
  finalHandoverFiles: 'finalHandoverFiles',
  finalFilesSubmittedAt: 'finalFilesSubmittedAt',
  finalizedAt: 'finalizedAt'
};

exports.Prisma.ProjectConceptEntryScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  conceptId: 'conceptId',
  revisionsRemaining: 'revisionsRemaining',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProjectActivityScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  type: 'type',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProjectEntryFeedbackScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  conceptId: 'conceptId',
  feedback: 'feedback',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProjectFileScalarFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  type: 'type',
  location: 'location',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  uploader: 'uploader'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SubscriptionScalarFieldEnum = {
  id: 'id',
  type: 'type',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  password: 'password',
  isShadowUser: 'isShadowUser',
  activeRoleId: 'activeRoleId',
  stripeCustomerId: 'stripeCustomerId',
  lastLoggedAt: 'lastLoggedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserFollowScalarFieldEnum = {
  id: 'id',
  followerId: 'followerId',
  followingId: 'followingId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserLegalDocumentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  documentId: 'documentId',
  signedAt: 'signedAt',
  ip: 'ip',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  conceptId: 'conceptId',
  pitchId: 'pitchId',
  signedAs: 'signedAs'
};

exports.Prisma.UserSubscriptionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  subscriptionId: 'subscriptionId',
  startsAt: 'startsAt',
  endsAt: 'endsAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserVerificationScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  method: 'method',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserEmailVerificationTokenScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  token: 'token',
  expiresAt: 'expiresAt',
  verifiedAt: 'verifiedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  internalName: 'internalName',
  internalDescription: 'internalDescription',
  stripeProductId: 'stripeProductId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ProductPricingScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  fromDate: 'fromDate',
  toDate: 'toDate',
  price: 'price',
  currencyCode: 'currencyCode',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SubscriptionPlanScalarFieldEnum = {
  id: 'id',
  productId: 'productId',
  billingInterval: 'billingInterval',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserInvoiceScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  stripeInvoiceId: 'stripeInvoiceId',
  currencyCode: 'currencyCode',
  amount: 'amount',
  status: 'status',
  subscriptionId: 'subscriptionId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reason: 'reason',
  lastPaymentError: 'lastPaymentError',
  link: 'link',
  countryId: 'countryId'
};

exports.Prisma.UserInvoiceLineItemScalarFieldEnum = {
  id: 'id',
  invoiceId: 'invoiceId',
  productId: 'productId',
  lineAmount: 'lineAmount',
  vatAmount: 'vatAmount',
  vatPercentage: 'vatPercentage',
  unitPrice: 'unitPrice',
  quantity: 'quantity',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SubscriptionV2ScalarFieldEnum = {
  id: 'id',
  status: 'status',
  userId: 'userId',
  planId: 'planId',
  startsAt: 'startsAt',
  endsAt: 'endsAt',
  providerId: 'providerId',
  data: 'data',
  renewedAt: 'renewedAt',
  renewedSubscriptionId: 'renewedSubscriptionId',
  downgradedAt: 'downgradedAt',
  downgradedToPlanId: 'downgradedToPlanId',
  upgradedAt: 'upgradedAt',
  upgradedToPlanId: 'upgradedToPlanId',
  cancelledAt: 'cancelledAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CurrencyScalarFieldEnum = {
  code: 'code',
  internalName: 'internalName',
  symbolNative: 'symbolNative',
  symbol: 'symbol',
  rounding: 'rounding',
  decimalDigits: 'decimalDigits',
  createdAt: 'createdAt'
};

exports.Prisma.UserPaymentMethodScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  stripeId: 'stripeId',
  log: 'log'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  userId: 'userId',
  expirationDate: 'expirationDate'
};

exports.Prisma.BrandInfoScalarFieldEnum = {
  id: 'id',
  email: 'email',
  mainFirstName: 'mainFirstName',
  mainLastName: 'mainLastName',
  profilePicture: 'profilePicture'
};

exports.Prisma.DesignerInfoScalarFieldEnum = {
  id: 'id',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  profilePicture: 'profilePicture'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.BrandProfileOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  profilePicture: 'profilePicture',
  companyName: 'companyName',
  vatNumber: 'vatNumber',
  address: 'address',
  city: 'city',
  zipCode: 'zipCode',
  countryId: 'countryId',
  phone: 'phone',
  description: 'description',
  interest: 'interest',
  mainFirstName: 'mainFirstName',
  mainLastName: 'mainLastName',
  mainEmail: 'mainEmail',
  mainPhone: 'mainPhone',
  mainMobile: 'mainMobile',
  mainTitle: 'mainTitle',
  website: 'website'
};

exports.Prisma.ConceptOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  authorId: 'authorId',
  coverImage: 'coverImage',
  sustainableElements: 'sustainableElements',
  mainCategory: 'mainCategory',
  subcategory1: 'subcategory1',
  subcategory2: 'subcategory2',
  description: 'description',
  tags: 'tags',
  reviewerId: 'reviewerId',
  boughtById: 'boughtById',
  reservedById: 'reservedById',
  templateId: 'templateId',
  pitchId: 'pitchId'
};

exports.Prisma.ConceptFileOrderByRelevanceFieldEnum = {
  id: 'id',
  conceptId: 'conceptId',
  name: 'name',
  location: 'location'
};

exports.Prisma.ConceptLogOrderByRelevanceFieldEnum = {
  id: 'id',
  conceptId: 'conceptId',
  coverImage: 'coverImage',
  description: 'description',
  mainCategory: 'mainCategory',
  subcategory1: 'subcategory1',
  subcategory2: 'subcategory2',
  sustainableElements: 'sustainableElements',
  tags: 'tags',
  title: 'title'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.ConceptActivityOrderByRelevanceFieldEnum = {
  id: 'id',
  conceptId: 'conceptId'
};

exports.Prisma.ConceptReviewOrderByRelevanceFieldEnum = {
  id: 'id',
  conceptId: 'conceptId',
  aboutReview: 'aboutReview'
};

exports.Prisma.ConceptSectionReviewOrderByRelevanceFieldEnum = {
  id: 'id',
  sectionId: 'sectionId',
  comment: 'comment'
};

exports.Prisma.ConceptSectionOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  images: 'images',
  text: 'text',
  conceptId: 'conceptId'
};

exports.Prisma.ConceptSectionLogOrderByRelevanceFieldEnum = {
  id: 'id',
  sectionId: 'sectionId',
  images: 'images',
  text: 'text',
  title: 'title'
};

exports.Prisma.ConceptStateHistoryOrderByRelevanceFieldEnum = {
  id: 'id',
  conceptId: 'conceptId'
};

exports.Prisma.ConceptTemplateOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.ConceptTemplateSectionOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  conceptTemplateId: 'conceptTemplateId'
};

exports.Prisma.CountryOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  alpha2: 'alpha2',
  alpha3: 'alpha3'
};

exports.Prisma.DesignerPortfolioOrderByRelevanceFieldEnum = {
  id: 'id',
  designerId: 'designerId',
  title: 'title',
  description: 'description',
  image: 'image',
  link: 'link'
};

exports.Prisma.DesignerProfileOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  slug: 'slug',
  firstName: 'firstName',
  lastName: 'lastName',
  address: 'address',
  city: 'city',
  zipCode: 'zipCode',
  countryId: 'countryId',
  phone: 'phone',
  level: 'level',
  workTitle: 'workTitle',
  linkedinProfile: 'linkedinProfile',
  website: 'website',
  mainDesignCompetency: 'mainDesignCompetency',
  profilePicture: 'profilePicture',
  educationLevel: 'educationLevel',
  educationProgram: 'educationProgram',
  educationTitle: 'educationTitle',
  educationYears: 'educationYears',
  educationInstitution: 'educationInstitution',
  educationCity: 'educationCity',
  educationCountryId: 'educationCountryId',
  diploma: 'diploma',
  billingCompanyName: 'billingCompanyName',
  billingAddress: 'billingAddress',
  billingCity: 'billingCity',
  billingZipCode: 'billingZipCode',
  billingCountryId: 'billingCountryId',
  billingVatNumber: 'billingVatNumber',
  billingPhone: 'billingPhone',
  bio: 'bio'
};

exports.Prisma.LegalDocumentOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  location: 'location'
};

exports.Prisma.NewsFeedOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  content: 'content',
  image: 'image'
};

exports.Prisma.PasswordResetOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  token: 'token'
};

exports.Prisma.PermissionOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.PitchOrderByRelevanceFieldEnum = {
  id: 'id',
  brandId: 'brandId',
  brandPaymentOption: 'brandPaymentOption',
  brandValues: 'brandValues',
  conceptTemplateId: 'conceptTemplateId',
  conceptsVisibleToBrands: 'conceptsVisibleToBrands',
  customBrandName: 'customBrandName',
  designStyle: 'designStyle',
  designerPaymentOption: 'designerPaymentOption',
  desiredRetailPriceDescription: 'desiredRetailPriceDescription',
  distributionChannelDescription: 'distributionChannelDescription',
  functionality: 'functionality',
  mainCategory: 'mainCategory',
  manufacturingRequirements: 'manufacturingRequirements',
  marketInformation: 'marketInformation',
  materials: 'materials',
  otherRemarks: 'otherRemarks',
  packagingDescription: 'packagingDescription',
  purpose: 'purpose',
  regulatoryRequirements: 'regulatoryRequirements',
  subcategory1: 'subcategory1',
  subcategory2: 'subcategory2',
  sustainablePrinciples: 'sustainablePrinciples',
  targetAudience: 'targetAudience',
  title: 'title',
  winningConceptId: 'winningConceptId',
  initiatedProjectId: 'initiatedProjectId'
};

exports.Prisma.PitchFeedbackOrderByRelevanceFieldEnum = {
  id: 'id',
  pitchId: 'pitchId',
  content: 'content',
  projectId: 'projectId'
};

exports.Prisma.PitchFileOrderByRelevanceFieldEnum = {
  id: 'id',
  pitchId: 'pitchId',
  userId: 'userId',
  location: 'location',
  name: 'name'
};

exports.Prisma.PitchActivityOrderByRelevanceFieldEnum = {
  id: 'id',
  pitchId: 'pitchId'
};

exports.Prisma.PitchDesignerInvitationOrderByRelevanceFieldEnum = {
  id: 'id',
  pitchId: 'pitchId',
  designerId: 'designerId'
};

exports.Prisma.ProjectOrderByRelevanceFieldEnum = {
  id: 'id',
  fromPitchId: 'fromPitchId',
  brandId: 'brandId',
  conceptTemplateId: 'conceptTemplateId',
  customBrandName: 'customBrandName',
  designerId: 'designerId',
  mainCategory: 'mainCategory',
  name: 'name',
  nextPhaseId: 'nextPhaseId',
  otherRemarks: 'otherRemarks',
  pitchConceptId: 'pitchConceptId',
  renumerationOptions: 'renumerationOptions',
  subcategory1: 'subcategory1',
  subcategory2: 'subcategory2',
  winningConceptId: 'winningConceptId',
  finalHandoverFiles: 'finalHandoverFiles'
};

exports.Prisma.ProjectConceptEntryOrderByRelevanceFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  conceptId: 'conceptId'
};

exports.Prisma.ProjectActivityOrderByRelevanceFieldEnum = {
  id: 'id',
  projectId: 'projectId'
};

exports.Prisma.ProjectEntryFeedbackOrderByRelevanceFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  conceptId: 'conceptId',
  feedback: 'feedback'
};

exports.Prisma.ProjectFileOrderByRelevanceFieldEnum = {
  id: 'id',
  projectId: 'projectId',
  location: 'location',
  name: 'name'
};

exports.Prisma.RoleOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.SubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  password: 'password',
  activeRoleId: 'activeRoleId',
  stripeCustomerId: 'stripeCustomerId'
};

exports.Prisma.UserFollowOrderByRelevanceFieldEnum = {
  id: 'id',
  followerId: 'followerId',
  followingId: 'followingId'
};

exports.Prisma.UserLegalDocumentOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  documentId: 'documentId',
  ip: 'ip',
  conceptId: 'conceptId',
  pitchId: 'pitchId'
};

exports.Prisma.UserSubscriptionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  subscriptionId: 'subscriptionId'
};

exports.Prisma.UserVerificationOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.UserEmailVerificationTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  token: 'token'
};

exports.Prisma.ProductOrderByRelevanceFieldEnum = {
  id: 'id',
  internalName: 'internalName',
  internalDescription: 'internalDescription',
  stripeProductId: 'stripeProductId'
};

exports.Prisma.ProductPricingOrderByRelevanceFieldEnum = {
  id: 'id',
  productId: 'productId',
  currencyCode: 'currencyCode'
};

exports.Prisma.SubscriptionPlanOrderByRelevanceFieldEnum = {
  id: 'id',
  productId: 'productId'
};

exports.Prisma.UserInvoiceOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  stripeInvoiceId: 'stripeInvoiceId',
  currencyCode: 'currencyCode',
  status: 'status',
  subscriptionId: 'subscriptionId',
  reason: 'reason',
  lastPaymentError: 'lastPaymentError',
  link: 'link',
  countryId: 'countryId'
};

exports.Prisma.UserInvoiceLineItemOrderByRelevanceFieldEnum = {
  id: 'id',
  invoiceId: 'invoiceId',
  productId: 'productId'
};

exports.Prisma.SubscriptionV2OrderByRelevanceFieldEnum = {
  id: 'id',
  status: 'status',
  userId: 'userId',
  planId: 'planId',
  providerId: 'providerId',
  renewedSubscriptionId: 'renewedSubscriptionId',
  downgradedToPlanId: 'downgradedToPlanId',
  upgradedToPlanId: 'upgradedToPlanId'
};

exports.Prisma.CurrencyOrderByRelevanceFieldEnum = {
  code: 'code',
  internalName: 'internalName',
  symbolNative: 'symbolNative',
  symbol: 'symbol'
};

exports.Prisma.UserPaymentMethodOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  stripeId: 'stripeId'
};

exports.Prisma.SessionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.BrandInfoOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  mainFirstName: 'mainFirstName',
  mainLastName: 'mainLastName',
  profilePicture: 'profilePicture'
};

exports.Prisma.DesignerInfoOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  profilePicture: 'profilePicture'
};
exports.ConceptType = exports.$Enums.ConceptType = {
  TRUST_CONCEPT: 'TRUST_CONCEPT',
  PITCH_CONCEPT: 'PITCH_CONCEPT',
  PROJECT_CONCEPT: 'PROJECT_CONCEPT'
};

exports.ConceptState = exports.$Enums.ConceptState = {
  DRAFT: 'DRAFT',
  SUBMITTED_FOR_REVIEW: 'SUBMITTED_FOR_REVIEW',
  SUBMITTED_NEED_REWORK: 'SUBMITTED_NEED_REWORK',
  SUBMITTED_IN_REWORK: 'SUBMITTED_IN_REWORK',
  REJECTED: 'REJECTED',
  APPROVED_FOR_PITCH: 'APPROVED_FOR_PITCH',
  REJECTED_FOR_PITCH: 'REJECTED_FOR_PITCH',
  SELECTED_FOR_PHASE2: 'SELECTED_FOR_PHASE2',
  NOT_SELECTED_FOR_PHASE2: 'NOT_SELECTED_FOR_PHASE2',
  SELECTED_FOR_PHASE3: 'SELECTED_FOR_PHASE3',
  NOT_SELECTED_FOR_PHASE3: 'NOT_SELECTED_FOR_PHASE3',
  SELECTED_FOR_PRODUCTION: 'SELECTED_FOR_PRODUCTION',
  REJECTED_FOR_PRODUCTION: 'REJECTED_FOR_PRODUCTION',
  APPROVED: 'APPROVED',
  RESERVED: 'RESERVED',
  SOLD: 'SOLD',
  DISCONTINUED: 'DISCONTINUED'
};

exports.ConceptPricingType = exports.$Enums.ConceptPricingType = {
  SPOT_FEE: 'SPOT_FEE',
  ROYALTY_FEE: 'ROYALTY_FEE',
  ROYALTY_DESIGN_FEE: 'ROYALTY_DESIGN_FEE',
  DESIGN_FEE: 'DESIGN_FEE',
  RESERVATION_FEE: 'RESERVATION_FEE'
};

exports.ConceptActivityType = exports.$Enums.ConceptActivityType = {
  ASSOCIATED_WITH_PITCH: 'ASSOCIATED_WITH_PITCH',
  ASSOCIATED_WITH_PROJECT: 'ASSOCIATED_WITH_PROJECT',
  STATE_CHANGED: 'STATE_CHANGED',
  SELECTED_FOR_PHASE2: 'SELECTED_FOR_PHASE2',
  SELECTED_FOR_PHASE3: 'SELECTED_FOR_PHASE3',
  RECEIVED_REVIEWER_FEEDBACK: 'RECEIVED_REVIEWER_FEEDBACK',
  RECEIVED_PITCH_FEEDBACK: 'RECEIVED_PITCH_FEEDBACK',
  RECEIVED_PROJECT_FEEDBACK: 'RECEIVED_PROJECT_FEEDBACK',
  PINNED_TO_REVIEW: 'PINNED_TO_REVIEW',
  UNPINNED_FROM_REVIEW: 'UNPINNED_FROM_REVIEW'
};

exports.ConceptTemplateSectionType = exports.$Enums.ConceptTemplateSectionType = {
  TEXT_AND_IMAGE: 'TEXT_AND_IMAGE',
  IMAGE_ONLY: 'IMAGE_ONLY'
};

exports.ConceptTemplateLayout = exports.$Enums.ConceptTemplateLayout = {
  ONE_BY_ONE: 'ONE_BY_ONE',
  TWO_BY_ONE: 'TWO_BY_ONE',
  TWO_BY_TWO_LEFT_COL_SPAN: 'TWO_BY_TWO_LEFT_COL_SPAN',
  TWO_BY_TWO: 'TWO_BY_TWO',
  THREE_BY_ONE: 'THREE_BY_ONE',
  THREE_BY_TWO: 'THREE_BY_TWO'
};

exports.LegalDocumentType = exports.$Enums.LegalDocumentType = {
  PITCH_TOS: 'PITCH_TOS',
  PITCH_NDA: 'PITCH_NDA',
  CONCEPT_SUBMISSION_AGREEMENT: 'CONCEPT_SUBMISSION_AGREEMENT',
  CONCEPT_MARKETING_AGREEMENT: 'CONCEPT_MARKETING_AGREEMENT',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  SUBSCRIPTION_NDA: 'SUBSCRIPTION_NDA',
  BROWSE_TRUST_TOS: 'BROWSE_TRUST_TOS'
};

exports.NewsFeedType = exports.$Enums.NewsFeedType = {
  POST: 'POST',
  RELEASE_NOTE: 'RELEASE_NOTE'
};

exports.PermissionType = exports.$Enums.PermissionType = {
  BROWSE_DESIGNERS: 'BROWSE_DESIGNERS',
  VIEW_DESIGNER: 'VIEW_DESIGNER',
  BROWSE_PITCHES: 'BROWSE_PITCHES',
  VIEW_PITCH: 'VIEW_PITCH',
  CREATE_PITCH: 'CREATE_PITCH',
  BROWSE_CONCEPTS: 'BROWSE_CONCEPTS',
  VIEW_CONCEPT: 'VIEW_CONCEPT'
};

exports.PitchRetailPrice = exports.$Enums.PitchRetailPrice = {
  ENTRY_LEVEL: 'ENTRY_LEVEL',
  MEDIUM_LEVEL: 'MEDIUM_LEVEL',
  PREMIUM_LEVEL: 'PREMIUM_LEVEL',
  LUXURY_LEVEL: 'LUXURY_LEVEL'
};

exports.PitchDistributionChannel = exports.$Enums.PitchDistributionChannel = {
  B2C: 'B2C',
  B2B: 'B2B',
  B2C_AND_B2B: 'B2C_AND_B2B'
};

exports.PitchState = exports.$Enums.PitchState = {
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  INITIATED: 'INITIATED',
  ENDED: 'ENDED',
  CANCELLED: 'CANCELLED'
};

exports.PitchFileUploader = exports.$Enums.PitchFileUploader = {
  BRAND: 'BRAND',
  DESIGNER: 'DESIGNER',
  ADMIN: 'ADMIN'
};

exports.PitchActivityType = exports.$Enums.PitchActivityType = {
  CONCEPT_APPROVED: 'CONCEPT_APPROVED',
  CONCEPT_STATE_CHANGED: 'CONCEPT_STATE_CHANGED',
  FEEDBACK_SENT: 'FEEDBACK_SENT',
  FEEDBACK_DELETED: 'FEEDBACK_DELETED',
  INVITATION_SENT: 'INVITATION_SENT',
  INVITATION_ACCEPTED: 'INVITATION_ACCEPTED',
  INVITATION_CANCELLED: 'INVITATION_CANCELLED',
  INVITATION_DECLINED: 'INVITATION_DECLINED',
  NDA_SIGNED: 'NDA_SIGNED',
  STATE_CHANGED: 'STATE_CHANGED',
  TOS_SIGNED: 'TOS_SIGNED',
  WINNING_CONCEPT_SELECTED: 'WINNING_CONCEPT_SELECTED',
  BRAND_SIGNED_TOS: 'BRAND_SIGNED_TOS'
};

exports.ProjectState = exports.$Enums.ProjectState = {
  DRAFT: 'DRAFT',
  INITIATED: 'INITIATED',
  OPEN: 'OPEN',
  ENDED: 'ENDED',
  CANCELLED: 'CANCELLED'
};

exports.ProjectActivityType = exports.$Enums.ProjectActivityType = {
  CONCEPT_SELECTED_FOR_PHASE3: 'CONCEPT_SELECTED_FOR_PHASE3',
  CONCEPT_SELECTED_FOR_PRODUCTION: 'CONCEPT_SELECTED_FOR_PRODUCTION',
  FEEDBACK_PROVIDED: 'FEEDBACK_PROVIDED',
  FEEDBACK_ACKNOWLEDGED: 'FEEDBACK_ACKNOWLEDGED',
  STATE_CHANGED: 'STATE_CHANGED',
  FILES_UPLOADED: 'FILES_UPLOADED',
  CONCEPT_STATE_CHANGED: 'CONCEPT_STATE_CHANGED',
  DESIGNER_ASSIGNED: 'DESIGNER_ASSIGNED',
  DESIGNER_UNASSIGNED: 'DESIGNER_UNASSIGNED',
  FINALIZED: 'FINALIZED'
};

exports.ProjectFileType = exports.$Enums.ProjectFileType = {
  FINAL: 'FINAL',
  PROTOTYPE: 'PROTOTYPE'
};

exports.ProjectFileUploader = exports.$Enums.ProjectFileUploader = {
  ADMIN: 'ADMIN',
  DESIGNER: 'DESIGNER',
  BRAND: 'BRAND'
};

exports.RoleType = exports.$Enums.RoleType = {
  ADMIN: 'ADMIN',
  DESIGNER: 'DESIGNER',
  BRAND: 'BRAND',
  REVIEWER: 'REVIEWER'
};

exports.SubscriptionType = exports.$Enums.SubscriptionType = {
  BRAND_LITE: 'BRAND_LITE',
  BRAND_BASIC: 'BRAND_BASIC',
  BRAND_PRO: 'BRAND_PRO'
};

exports.UserVerificationMethod = exports.$Enums.UserVerificationMethod = {
  TOKEN: 'TOKEN',
  MANUAL: 'MANUAL'
};

exports.Prisma.ModelName = {
  BrandProfile: 'BrandProfile',
  Concept: 'Concept',
  ConceptFile: 'ConceptFile',
  ConceptLog: 'ConceptLog',
  ConceptActivity: 'ConceptActivity',
  ConceptReview: 'ConceptReview',
  ConceptSectionReview: 'ConceptSectionReview',
  ConceptSection: 'ConceptSection',
  ConceptSectionLog: 'ConceptSectionLog',
  ConceptStateHistory: 'ConceptStateHistory',
  ConceptTemplate: 'ConceptTemplate',
  ConceptTemplateSection: 'ConceptTemplateSection',
  Country: 'Country',
  DesignerPortfolio: 'DesignerPortfolio',
  DesignerProfile: 'DesignerProfile',
  LegalDocument: 'LegalDocument',
  NewsFeed: 'NewsFeed',
  PasswordReset: 'PasswordReset',
  Permission: 'Permission',
  Pitch: 'Pitch',
  PitchFeedback: 'PitchFeedback',
  PitchFile: 'PitchFile',
  PitchActivity: 'PitchActivity',
  PitchDesignerInvitation: 'PitchDesignerInvitation',
  Project: 'Project',
  ProjectConceptEntry: 'ProjectConceptEntry',
  ProjectActivity: 'ProjectActivity',
  ProjectEntryFeedback: 'ProjectEntryFeedback',
  ProjectFile: 'ProjectFile',
  Role: 'Role',
  Subscription: 'Subscription',
  User: 'User',
  UserFollow: 'UserFollow',
  UserLegalDocument: 'UserLegalDocument',
  UserSubscription: 'UserSubscription',
  UserVerification: 'UserVerification',
  UserEmailVerificationToken: 'UserEmailVerificationToken',
  Product: 'Product',
  ProductPricing: 'ProductPricing',
  SubscriptionPlan: 'SubscriptionPlan',
  UserInvoice: 'UserInvoice',
  UserInvoiceLineItem: 'UserInvoiceLineItem',
  SubscriptionV2: 'SubscriptionV2',
  Currency: 'Currency',
  UserPaymentMethod: 'UserPaymentMethod',
  Session: 'Session',
  BrandInfo: 'BrandInfo',
  DesignerInfo: 'DesignerInfo'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
